import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { FormGroup, ControlLabel, Modal } from "react-bootstrap";

import AlmigButton from "../grundelemente/AlmigButton";
import DisabledOverlay from "../grundelemente/DisabledOverlay";
import { postJSONexpectText } from "../netzwerk/FetchWithToken";

import ApplyDismiss from "./ApplyDismiss";
import { saveSettings } from "./SaveSettings";
import SelectControl, { SelectOption } from "./SelectControl";
import { stateFromModel, modelFromLocal, changeState, recheckState }
	from "./SettingsValue";

import "./Benutzer.css";

const default_local = {
	start_page: null
};

const PASSWD_DEMO = "demo";
const PASSWD_READ = "read";
const PASSWD_WRITE = "write";
const STEP_PASSWD1 = 0;
const STEP_PASSWD2 = 1;
const STEP_NOMATCH = 2;
const STEP_CONFIRM = 3;

const PW_TEXT_MAP = {
	[PASSWD_DEMO]: "Password for demo access",
	[PASSWD_READ]: "Password for read access",
	[PASSWD_WRITE]: "Password for write access",
}

const getPWEntryTextId = (pw) => {
	let result = PW_TEXT_MAP[pw];
	if (!result) {
		result = "Password";
	}
	return result;
}

class Benutzer extends React.Component {

	static propTypes = {
		user: PropTypes.object.isRequired,
		auth: PropTypes.object.isRequired
	};
		
	constructor(props, context) {
		super(props, context);
		this.handleChange = this.handleChange.bind(this);
		this.apply = this.apply.bind(this);
		this.dismiss = this.dismiss.bind(this);
		this.state = this.genState();
		this.state.which_passwd = null;
		this.state.step = STEP_PASSWD1;
		this.state.new_passwds = ["", ""];
		this.startChangePasswd = this.startChangePasswd.bind(this);
		this.handlePasswd = this.handlePasswd.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.stopChangePasswd = this.stopChangePasswd.bind(this);
		this.passwdInput = null;
		this.setPasswdInputRef = element => {
			/* input für später (passwd2) merken */
			this.passwdInput = element;
			if (element) {
				/* und gleich jetzt schon den Fokus vergeben (passwd1) */
				element.focus();
			}
		};
		this.focusPasswdInput = () => {
			if (this.passwdInput) {
				this.passwdInput.focus();
			}
		};
	}
	genState() { return stateFromModel(default_local, this.props.user, Benutzer.validate); }
	apply() {
		let value = modelFromLocal(this.state.local);
		saveSettings("user", value);
	}
	dismiss() {
		this.setState(this.genState());
	}
	static validate() {
		return true;
	}
	handleChange(e) {
		this.setState(changeState(e.target.name, e.target.value, this.state, Benutzer.validate));
	}
	componentWillReceiveProps(nextProps) {
		let change = recheckState(this.state, nextProps.user, Benutzer.validate);
		if (change) {
			this.setState(change);
		}
	}
	startChangePasswd(which_passwd) {
		this.setState({
			which_passwd,
			step: STEP_PASSWD1,
			new_passwds: ["", ""]
		});
	}
	handlePasswd(e) {
		this.setState({
			new_passwds: [
				this.state.step === STEP_PASSWD1 ? e.target.value : this.state.new_passwds[0],
				this.state.step === STEP_PASSWD2 ? e.target.value : this.state.new_passwds[1]
			]
		});
	}
	handleClick() {
		switch (this.state.step) {
		case STEP_PASSWD1:
			this.setState({ step: STEP_PASSWD2 });
			this.focusPasswdInput();	/* Fokus auf input (erneut) */
			break;
		case STEP_PASSWD2: this.setState({
			step: this.state.new_passwds[0] === this.state.new_passwds[1]
				? STEP_CONFIRM : STEP_NOMATCH
		});
			break;
		case STEP_NOMATCH: this.startChangePasswd(this.state.which_passwd); break;
		case STEP_CONFIRM: this.stopChangePasswd(); break;
		default:
			break;
		}
	}
	stopChangePasswd() {
		this.setState({
			which_passwd: null
		});
	}
	render() {
		let { which_passwd, step, new_passwds } = this.state;
		return (
			<div>
				<DisabledOverlay disabled={!this.props.auth.canWrite} />
				<form className="Benutzer">
					<FormGroup>
						<ControlLabel>
							<FormattedMessage id="Password for demo access" />
						</ControlLabel>
						<AlmigButton i18n_key="Change" onClick={() => this.startChangePasswd(PASSWD_DEMO)} />
					</FormGroup>
					<FormGroup>
						<ControlLabel>
							<FormattedMessage id="Password for read access" />
						</ControlLabel>
						<AlmigButton i18n_key="Change" onClick={() => this.startChangePasswd(PASSWD_READ)} />
					</FormGroup>
					<FormGroup>
						<ControlLabel>
							<FormattedMessage id="Password for write access" />
						</ControlLabel>
						<AlmigButton i18n_key="Change" onClick={() => this.startChangePasswd(PASSWD_WRITE)} />
					</FormGroup>
					<SelectControl i18n_key="Initial screen" prop="start_page"
						local={this.state.local} handleChange={this.handleChange}>
						<SelectOption value="/overview" i18n_key="Overview" />
						{/*<SelectOption value="/analysis" i18n_key="Analysis" />
						<SelectOption value="/think_green" i18n_key="Think Green" />*/}
						<SelectOption value="/maintenance" i18n_key="Maintenance" />
						{/*<SelectOption value="/error_log" i18n_key="Error Log" />
						<SelectOption value="/data_archive" i18n_key="Data archive" />*/}
						<SelectOption value="/settings" i18n_key="Settings" />
					</SelectControl>
				</form>
				<ApplyDismiss state={this.state} apply={this.apply} dismiss={this.dismiss} />
				<Modal show={which_passwd !== null} aria-labelledby="contained-modal-title">
					<Modal.Header>
						<Modal.Title id="contained-modal-title">
							<FormattedMessage id={getPWEntryTextId(which_passwd)} />
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{ step < STEP_NOMATCH
							? <input className="form-control" type="text" onChange={this.handlePasswd}
								value={step === STEP_PASSWD1 ? new_passwds[0] : new_passwds[1]}
								onKeyPress={e => { if (e.charCode === 13) { this.handleClick(); }} }
								ref={this.setPasswdInputRef}/>
							: <FormattedMessage id={step === STEP_NOMATCH
								? "Passwords do not match!"
								: "Passwords match. Choose 'Apply' to continue."} />
						}
					</Modal.Body>
					<Modal.Footer>
						{ (step === STEP_PASSWD1 || step === STEP_PASSWD2)
							? <AlmigButton i18n_key="Continue" onClick={this.handleClick} />
							: step === STEP_NOMATCH
								? <AlmigButton i18n_key="Retry" onClick={() => {
									this.startChangePasswd(which_passwd);
								}} />
								: <AlmigButton i18n_key="Apply" onClick={() => {
									postJSONexpectText("/settings/user/passwd", {
										which: which_passwd,
										new_passwd: new_passwds[0]
									}).then(response => {
										return response.text().then(text => {
											if (!response.ok || text !== "OK") {
												alert(text);
											}
										});
									}).catch(error => {
										alert(error);
									});
									this.stopChangePasswd();
								}} />
						}
						<AlmigButton i18n_key="Cancel" onClick={() => {
							this.stopChangePasswd();
						}} />
					</Modal.Footer>
				</Modal>
			</div>
		);
	}
}

export default Benutzer;
